import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import type { CreditNoteLink } from '@/hooks/useInvoices';

export function CreditNoteLinks({ notes }: { notes: CreditNoteLink[] }) {
  const { t } = useTranslation();
  if (notes.length === 0) return null;
  return (
    <ul className="mt-1 space-y-0.5" data-credit-note-links="">
      {notes.map((note) => (
        <li key={note.id}>
          <Link className="text-ds-teal hover:text-ds-teal-700" to={`/invoices/${note.id}`}>
            {note.invoice_number
              ? t('invoices.credit_note_link', { number: note.invoice_number })
              : t('invoices.credit_note_link_untitled')}
          </Link>
        </li>
      ))}
    </ul>
  );
}
